// services/aboutService.js
import { apiClient } from "../../base/ApiClient";

const BASE_URL = '/client';

export const aboutService = {
  getAboutForms: async () => {
    const response = await apiClient.get(`${BASE_URL}/about-forms/`);
    return response.data;
  },

  getActiveAboutForms: async () => {
    const response = await apiClient.get(`${BASE_URL}/about-forms/active_forms/`);
    return response.data;
  },

  getAboutForm: async (id) => {
    const response = await apiClient.get(`${BASE_URL}/about-forms/${id}/`);
    return response.data;
  },

  getAboutFormFullStructure: async (id) => {
    const response = await apiClient.get(`${BASE_URL}/about-forms/${id}/full_structure/`);
    return response.data;
  },

  createAboutForm: async (data) => {
    const response = await apiClient.post(`${BASE_URL}/about-forms/`, data);
    return response.data;
  },

  updateAboutForm: async (id, data) => {
    const response = await apiClient.put(`${BASE_URL}/about-forms/${id}/`, data);
    return response.data;
  },

  deleteAboutForm: async (id) => {
    const response = await apiClient.delete(`${BASE_URL}/about-forms/${id}/`);
    return response.data;
  },

  getAboutSections: async (params) => {
    const response = await apiClient.get(`${BASE_URL}/about-sections/`, { params });
    return response.data;
  },

  getAboutSection: async (id) => {
    const response = await apiClient.get(`${BASE_URL}/about-sections/${id}/`);
    return response.data;
  },

  createAboutSection: async (data) => {
    const response = await apiClient.post(`${BASE_URL}/about-sections/`, data);
    return response.data;
  },

  updateAboutSection: async (id, data) => {
    const response = await apiClient.put(`${BASE_URL}/about-sections/${id}/`, data);
    return response.data;
  },

  deleteAboutSection: async (id) => {
    const response = await apiClient.delete(`${BASE_URL}/about-sections/${id}/`);
    return response.data;
  },

  getAboutFields: async (params) => {
    const response = await apiClient.get(`${BASE_URL}/about-fields/`, { params });
    return response.data;
  },

  getAboutField: async (id) => {
    const response = await apiClient.get(`${BASE_URL}/about-fields/${id}/`);
    return response.data;
  },

  createAboutField: async (data) => {
    const response = await apiClient.post(`${BASE_URL}/about-fields/`, data);
    return response.data;
  },

  updateAboutField: async (id, data) => {
    const response = await apiClient.put(`${BASE_URL}/about-fields/${id}/`, data);
    return response.data;
  },

  deleteAboutField: async (id) => {
    const response = await apiClient.delete(`${BASE_URL}/about-fields/${id}/`);
    return response.data;
  },

  getAboutSubmissions: async (params) => {
    const response = await apiClient.get(`${BASE_URL}/about-submissions/`, { params });
    return response.data;
  },

  getAboutSubmission: async (id) => {
    const response = await apiClient.get(`${BASE_URL}/about-submissions/${id}/`);
    return response.data;
  },

  createAboutSubmission: async (data) => {
    const response = await apiClient.post(`${BASE_URL}/about-submissions/`, data);
    return response.data;
  },

  updateAboutSubmission: async (id, data) => {
    const response = await apiClient.put(`${BASE_URL}/about-submissions/${id}/`, data);
    return response.data;
  },

  deleteAboutSubmission: async (id) => {
    const response = await apiClient.delete(`${BASE_URL}/about-submissions/${id}/`);
    return response.data;
  },

  getClientAboutSubmissions: async (clientId) => {
    const response = await apiClient.get(`${BASE_URL}/about-submissions/client_submissions/`, {
      params: { client_id: clientId }
    });
    return response.data;
  },

  getLatestAboutSubmission: async (clientId, formId) => {
    const response = await apiClient.get(`${BASE_URL}/about-submissions/latest_by_client/`, {
      params: { client_id: clientId, form_id: formId }
    });
    return response.data;
  },

  submitAboutForm: async (clientId, formId, responses) => {
    const response = await apiClient.post(`${BASE_URL}/about-submissions/`, {
      client: parseInt(clientId),
      form: parseInt(formId),
      responses: responses
    });
    return response.data;
  },

  getClientAbout: async (clientId) => {
    const response = await apiClient.get(`${BASE_URL}/about-submissions/client_submissions/`, {
      params: { client_id: clientId }
    });
    return response.data;
  },

  getClientLatestAbout: async (clientId) => {
    const activeForms = await aboutService.getActiveAboutForms();
    if (activeForms && activeForms.length > 0) {
      const formId = activeForms[0].id;
      const response = await apiClient.get(`${BASE_URL}/about-submissions/latest_by_client/`, {
        params: { client_id: clientId, form_id: formId }
      });
      return response.data;
    }
    return null;
  },

  getFormSubmissions: async (formId) => {
    const response = await apiClient.get(`${BASE_URL}/about-submissions/`, {
      params: { form_id: formId }
    });
    return response.data;
  }
};